// extracted by mini-css-extract-plugin
export default {"search-symbol-page-container":"uj1s7MOj23ybQPWL6x1o","close-btn":"lG_7NSyzhWs0dl_2lLVz"};